(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dicci-product-accordion"] && !Shopify.designMode) return;
  try {
    if (!window.__dicciAccInit) {
    window.__dicciAccInit = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.dicci-acc__trigger');
      if (!trigger) return;
      var body = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!body) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      body.hidden = expanded;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
